import { useState } from "react";
import { useAudit } from "../hooks/useAudit.js";
import { formatDate } from "../lib/format.js";

export function AuditPage() {
  const [actor, setActor] = useState("");
  const [action, setAction] = useState("");
  const [target, setTarget] = useState("");

  const { data, isLoading, error } = useAudit({ actor, action, target });

  return (
    <div>
      <h1 className="page-title">审计日志</h1>
      <p className="page-sub">所有 admin 写操作,时间倒序 · 筛选后点清空恢复</p>

      <div
        className="card"
        style={{
          display: "flex",
          gap: 10,
          padding: 12,
          marginTop: 20,
          marginBottom: 20,
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <input
          placeholder="actor id"
          value={actor}
          onChange={(e) => setActor(e.target.value)}
          style={{ flex: 1, minWidth: 150, height: 32 }}
        />
        <input
          placeholder="action"
          value={action}
          onChange={(e) => setAction(e.target.value)}
          style={{ flex: 1, minWidth: 150, height: 32 }}
        />
        <input
          placeholder="target(模糊)"
          value={target}
          onChange={(e) => setTarget(e.target.value)}
          style={{ flex: 1, minWidth: 150, height: 32 }}
        />
        {(actor || action || target) && (
          <button
            className="btn btn-ghost btn-sm"
            onClick={() => {
              setActor("");
              setAction("");
              setTarget("");
            }}
          >
            清空
          </button>
        )}
      </div>

      {isLoading && <div className="empty">加载中…</div>}
      {error && <div className="err">{(error as Error).message}</div>}

      {data && (
        <table className="table">
          <thead>
            <tr>
              <th style={{ width: 160 }}>时间</th>
              <th style={{ width: 120 }}>actor</th>
              <th style={{ width: 160 }}>action</th>
              <th>target</th>
              <th>meta</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={5} className="empty">
                  无匹配记录
                </td>
              </tr>
            ) : (
              data.map((row) => (
                <tr key={row.id}>
                  <td style={{ color: "var(--text-muted)", fontSize: 12 }}>
                    {formatDate(row.ts)}
                  </td>
                  <td>
                    <code style={{ fontSize: 11 }}>{row.actor_id.slice(0, 8)}…</code>
                  </td>
                  <td>
                    <span className="pill pill-neutral">{row.action}</span>
                  </td>
                  <td>
                    <code style={{ fontSize: 12 }}>{row.target}</code>
                  </td>
                  <td>
                    {row.meta_json ? (
                      <code
                        style={{
                          fontSize: 10,
                          color: "var(--text-muted)",
                          maxWidth: 300,
                          display: "inline-block",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {row.meta_json}
                      </code>
                    ) : (
                      "—"
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
